import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg13"
    viewBox="0 0 248.78 250.47"
    {...props}
  >
    <defs id="defs4">
      <style id="style2">{".cls-1{fill:#b7b7b7}"}</style>
    </defs>
    <title id="title6">{"IconeComanda"}</title>
    <path
      id="path4"
      strokeMiterlimit={10}
      d="m189.782 22.4-14.305 19.657-12.855-21.595-16.437 21.318-10.56-21.595-17.369 20.367-18.752-20.543L80.79 40.552l-17.647-19.71-19.478 19.71V208.67l11.303 19.966 17.308-19.966 16.234 21.6 12.375-21.6L115.87 227l10.56-21.872 14.646 17.716 11.922-14.175 16.348 19.712 10.219-19.712 16.694 19.989 8.856-19.99V40.553Z"
      style={{
        fill: "none",
        stroke: "#b7b7b7",
        strokeWidth: 9,
        strokeMiterlimit: 10,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
    />
    <g id="g851" transform="translate(.704)">
      <g
        id="text6"
        aria-label="SENHA"
        style={{
          fontSize: "16.23248291px",
          fontFamily: "&quot",
          fill: "#b7b7b7",
          fillOpacity: 1,
          stroke: "none",
          strokeWidth: 1.05976903,
          strokeMiterlimit: 10,
          strokeOpacity: 1,
        }}
        transform="matrix(1.55556 0 0 1.7717 -76.885 -55.914)"
      >
        <path
          id="path843"
          d="M109.055 72.057v1.561q-.911-.436-1.72-.65-.808-.214-1.561-.214-1.308 0-2.021.507-.706.508-.706 1.443 0 .785.468 1.189.475.396 1.791.642l.967.198q1.791.34 2.64 1.205.855.856.855 2.298 0 1.72-1.157 2.608-1.15.888-3.376.888-.84 0-1.792-.19-.943-.19-1.957-.563V81.33q.975.547 1.91.824.935.278 1.839.278 1.37 0 2.116-.54.745-.538.745-1.537 0-.872-.539-1.363-.531-.492-1.752-.737l-.975-.19q-1.79-.357-2.591-1.118-.8-.761-.8-2.116 0-1.57 1.1-2.473 1.11-.904 3.052-.904.833 0 1.697.15.863.151 1.767.453z"
          style={{
            fontSize: "16.23248291px",
            fontFamily: "&quot",
            fill: "#b7b7b7",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 1.05976903,
            strokeMiterlimit: 10,
            strokeOpacity: 1,
          }}
        />
        <path
          id="path845"
          d="M112.265 71.668h7.482v1.348h-5.88v3.503h5.635v1.347h-5.636v4.288h6.024v1.348h-7.625z"
          style={{
            fontSize: "16.23248291px",
            fontFamily: "&quot",
            fill: "#b7b7b7",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 1.05976903,
            strokeMiterlimit: 10,
            strokeOpacity: 1,
          }}
        />
        <path
          id="path847"
          d="M122.537 71.668h2.156l5.247 9.9v-9.9h1.554v11.834h-2.156l-5.247-9.9v9.9h-1.554z"
          style={{
            fontSize: "16.23248291px",
            fontFamily: "&quot",
            fill: "#b7b7b7",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 1.05976903,
            strokeMiterlimit: 10,
            strokeOpacity: 1,
          }}
        />
        <path
          id="path849"
          d="M134.68 71.668h1.6v4.85h5.819v-4.85h1.6v11.834h-1.6v-5.636h-5.818v5.636h-1.601z"
          style={{
            fontSize: "16.23248291px",
            fontFamily: "&quot",
            fill: "#b7b7b7",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 1.05976903,
            strokeMiterlimit: 10,
            strokeOpacity: 1,
          }}
        />
        <path
          id="path851"
          d="m150.841 73.245-2.172 5.89h4.352zm-.904-1.577h1.816l4.51 11.834h-1.665l-1.078-3.036h-5.334l-1.078 3.036h-1.688z"
          style={{
            fontSize: "16.23248291px",
            fontFamily: "&quot",
            fill: "#b7b7b7",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 1.05976903,
            strokeMiterlimit: 10,
            strokeOpacity: 1,
          }}
        />
      </g>
      <path
        id="path854"
        d="M98.226 123.185q0-6.988-1.162-9.833-1.14-2.87-3.856-2.87-2.717 0-3.878 2.87-1.162 2.845-1.162 9.833 0 7.062 1.162 9.957 1.16 2.895 3.878 2.895 2.695 0 3.856-2.895 1.162-2.895 1.162-9.957zm8.435.075q0 9.258-3.505 14.3-3.506 5.015-9.948 5.015-6.464 0-9.97-5.016-3.506-5.04-3.506-14.3 0-9.283 3.506-14.3 3.506-5.04 9.97-5.04 6.442 0 9.948 5.04 3.505 5.017 3.505 14.3z"
        style={{
          fontStyle: "normal",
          fontVariant: "normal",
          fontWeight: 700,
          fontStretch: "normal",
          fontSize: "38.50434494px",
          fontFamily: "&quot",
          InkscapeFontSpecification: "&quot",
          fill: "#b7b7b7",
          fillOpacity: 1,
          stroke: "none",
          strokeWidth: 2.84775567,
          strokeMiterlimit: 10,
        }}
      />
      <path
        id="path856"
        d="M129.427 123.185q0-6.988-1.161-9.833-1.14-2.87-3.856-2.87-2.717 0-3.879 2.87-1.161 2.845-1.161 9.833 0 7.062 1.161 9.957 1.162 2.895 3.879 2.895 2.695 0 3.856-2.895t1.161-9.957zm8.436.075q0 9.258-3.506 14.3-3.506 5.015-9.947 5.015-6.464 0-9.97-5.016-3.506-5.04-3.506-14.3 0-9.283 3.506-14.3 3.506-5.04 9.97-5.04 6.441 0 9.947 5.04 3.506 5.017 3.506 14.3z"
        style={{
          fontStyle: "normal",
          fontVariant: "normal",
          fontWeight: 700,
          fontStretch: "normal",
          fontSize: "38.50434494px",
          fontFamily: "&quot",
          InkscapeFontSpecification: "&quot",
          fill: "#b7b7b7",
          fillOpacity: 1,
          stroke: "none",
          strokeWidth: 2.84775567,
          strokeMiterlimit: 10,
        }}
      />
      <path
        id="path858"
        d="M160.892 121.762q3.308.973 5.018 3.394 1.73 2.396 1.73 6.114 0 5.54-3.724 8.435-3.725 2.87-10.868 2.87-2.52 0-5.062-.474-2.52-.449-4.996-1.372v-7.412q2.367 1.347 4.69 2.046 2.344.674 4.6.674 3.353 0 5.128-1.323 1.797-1.322 1.797-3.793 0-2.546-1.84-3.843-1.82-1.323-5.391-1.323H148.6v-6.189h3.55q3.176 0 4.732-1.123 1.556-1.148 1.556-3.469 0-2.146-1.512-3.319t-4.273-1.173q-2.038 0-4.12.524-2.08.524-4.14 1.547v-7.037q2.498-.799 4.952-1.198 2.454-.4 4.82-.4 6.376 0 9.532 2.396 3.177 2.371 3.177 7.163 0 3.269-1.512 5.365-1.512 2.072-4.47 2.92z"
        style={{
          fontStyle: "normal",
          fontVariant: "normal",
          fontWeight: 700,
          fontStretch: "normal",
          fontSize: "38.50434494px",
          fontFamily: "&quot",
          InkscapeFontSpecification: "&quot",
          fill: "#b7b7b7",
          fillOpacity: 1,
          stroke: "none",
          strokeWidth: 2.84775567,
          strokeMiterlimit: 10,
        }}
      />
    </g>
  </svg>
)
export default SvgComponent
